import * as React from "react";
import classnames from "classnames";
import { AnimatePresence } from "motion/react";
import { toast } from "@grandvisionhq/common";
import { CheckboxWithLabel } from "@grandvisionhq/forms";
import { useDispatch, useIntl, useSelector } from "@grandvisionhq/state";
import { toggleDeliveryAddress } from "../../../../../../../StepShipping/actions.js";
import { isBillingAndShippingAddressSame, getSelectedShippingMethod, getBillingAddress, getDeliveryAddress, hasStoredDeliveryAddress } from "../../../../../../../StepShipping/selectors.js";
/* empty css                            */
import { ShippingMethod } from "../../../../../../../../models/step-shipping/models/step-shipping/shipping-methods.js";
import { BillingForm } from "../../../../../../Forms/StepShipping/components/Forms/BillingForm.js";
import { DeliveryForm } from "../../../../../../Forms/StepShipping/components/Forms/DeliveryForm.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
import { isDelivery, isDeliveryExpress } from "../../../../../../../../utils/utils/shipping-method.js";
const BillingAndDeliveryForm = ({ className }) => {
  const checkoutSettings = useCheckoutSettings();
  const dispatch = useDispatch();
  const { getLabel } = useIntl();
  const isBillingAndDeliverySame = useSelector(isBillingAndShippingAddressSame);
  const selectedShippingMethod = useSelector(getSelectedShippingMethod);
  const billingAddressDetails = useSelector(getBillingAddress);
  const deliveryAddressDetails = useSelector(getDeliveryAddress);
  const isDelivery$1 = isDelivery(selectedShippingMethod?.method);
  const isDeliveryExpress$1 = isDeliveryExpress(selectedShippingMethod?.method);
  const hasStoredDeliveryAddressBoolean = useSelector(hasStoredDeliveryAddress);
  const labels = React.useMemo(
    () => ({
      differentDeliveryAddress: getLabel("checkout.shipment.differentDeliveryAddress"),
      deliveryAddress: getLabel("checkout.deliveryAddress")
    }),
    [getLabel]
  );
  const isDeliveryAddressRequired = React.useMemo(
    () => isDelivery$1 && Boolean(checkoutSettings.shipping?.requiredShippingCountry) && Boolean(billingAddressDetails?.country) && checkoutSettings.shipping?.requiredShippingCountry !== billingAddressDetails?.country,
    [billingAddressDetails?.country, checkoutSettings.shipping?.requiredShippingCountry, isDelivery$1]
  );
  const onToggleDeliveryAddress = React.useCallback(
    ({ checked }) => {
      if (isDeliveryAddressRequired) {
        toast.failed("checkout.address.requiredShippingCountry.errorMessage");
      } else {
        dispatch(toggleDeliveryAddress({ enabled: !checked }));
      }
    },
    [dispatch, isDeliveryAddressRequired]
  );
  React.useEffect(() => {
    if (isDeliveryAddressRequired) {
      dispatch(toggleDeliveryAddress({ enabled: true }));
    }
  }, [isDeliveryAddressRequired, dispatch]);
  React.useEffect(() => {
    if (!isBillingAndDeliverySame && hasStoredDeliveryAddressBoolean && (selectedShippingMethod?.method === ShippingMethod.Delivery || selectedShippingMethod?.method === ShippingMethod.DeliveryExpress)) {
      dispatch(toggleDeliveryAddress({ enabled: true }));
    }
  }, []);
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: classnames("billing-and-delivery-form", className),
      "data-t": "billing-and-delivery-form"
    },
    /* @__PURE__ */ React.createElement(BillingForm, null),
    (isDelivery$1 || isDeliveryExpress$1) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      CheckboxWithLabel,
      {
        id: "usingDeliveryAddress",
        value: "usingDeliveryAddress",
        "data-t": "usingDeliveryAddress",
        checked: !Boolean(deliveryAddressDetails),
        onChange: onToggleDeliveryAddress,
        className: "billing-and-delivery-form__checkbox",
        label: labels.differentDeliveryAddress
      }
    ), /* @__PURE__ */ React.createElement(AnimatePresence, null, deliveryAddressDetails && (isDeliveryAddressRequired || !isBillingAndDeliverySame) && /* @__PURE__ */ React.createElement(DeliveryForm, { deliveryAddressLabel: labels.deliveryAddress })))
  );
};
export {
  BillingAndDeliveryForm
};
//# sourceMappingURL=BillingAndDeliveryForm.js.map
